import { render, staticRenderFns } from "./BindsAppToolbar.vue?vue&type=template&id=c24e6fae&"
import script from "./BindsAppToolbar.vue?vue&type=script&lang=js&"
export * from "./BindsAppToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BindsAppToolbar.vue?vue&type=style&index=0&id=c24e6fae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports